import { useAppAlert } from '@/app/AppAlertProvider'
import DocumentUploadNew from '@/app/common/components/Documents/DocumentUploadNew'
import UploadedFileSelection from '@/app/common/components/uploaded_file_preview/uploaded_file_selection'
import { useTemporaryFileUpload } from '@/app/common/hooks/useTemporaryFileUpload'
import { parseRequestError } from '@/app/common/utilities'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'


type Props = {
  onNext: (files: string[]) => void
  defaultValues: string[],
  onUploadedDocumentRemove: (index: number) => void
}

export const NewReimubrusementCaptureImages = (props: Props) => {
  const { onNext, defaultValues, onUploadedDocumentRemove } = props
  const { t: translate } = useTranslation()
  const [step, setStep] = useState<'upload' | 'review'>(() => {
    return defaultValues.length === 0 ? 'upload' : 'review'
  })
  const [files, setFiles] = useState<File[]>([])
  const { fireAlert } = useAppAlert()
  const mutation = useTemporaryFileUpload({
    onError: (error) => {
      const parsedError = parseRequestError(error)

      fireAlert({
        title: true,
        titleText: translate('document_upload_error'),
        message: parsedError.message,
        variant: 'error',
      })
    },
    onSuccess: (data) => {
      onNext(data.map((item) => item.file_name))
    },
  })
  const numberOfUploadedDocuments = defaultValues.length + files.length

  const handleUploadDocuments = () => {
    if (numberOfUploadedDocuments === 0) {
      // Show error if no documents are uploaded
      fireAlert({
        title: true,
        titleText: translate('no_documents_error'),
        message: translate('select_atleast_one_document_to_continue'),

        variant: 'error',
      })
      return
    }

    // Proceed with upload if there are files
    mutation.mutate(files)
  }

  if (step === 'upload') {
    return (
      <FamilyWizardLayout>
        <FamilyWizardLayout.Header>
          <h1>{translate('upload_images')}</h1>
        </FamilyWizardLayout.Header>
        <FamilyWizardLayout.Content className=" items-center w-full  justify-center">
          <DocumentUploadNew
            allowMultiple={true}
            isPdfAllowed={true}
            onUpload={(files) => {
              setFiles(files)
              setStep('review')
            }}
          />
        </FamilyWizardLayout.Content>
      </FamilyWizardLayout>
    )
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('upload_images')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className=" items-center w-full ">
        <div className="space-y-4 w-full">
          <UploadedFileSelection
            onUploadedDocumentRemove={(index) => {
              onUploadedDocumentRemove(index)
            }}
            onUploadDocumentsClick={handleUploadDocuments}
            onUploadMoreDocsClick={() => {
              setStep('upload')
            }}
            uploadStatus={mutation.status}
            onRemove={(index) => {
              setFiles((files) =>
                files.filter((_, fileIndex) => index !== fileIndex)
              )
            }}
            uploadedDocuments={defaultValues}
            files={files}
          />
        </div>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}
